"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebcamCapability = void 0;
var WebcamCapability = /** @class */ (function () {
    function WebcamCapability() {
        this.properties = {
            width: 320,
            height: 320,
        };
    }
    WebcamCapability.prototype.generate = function (dest) {
        // TODO: Figure out how to read from the webcam.
        throw new Error("Method not implemented.");
    };
    WebcamCapability.prototype.setParameter = function (name, value) {
        var properties = this.properties;
        properties[name] = value;
    };
    return WebcamCapability;
}());
exports.WebcamCapability = WebcamCapability;
